import * as React from "react"

import { Navbar } from "./Navbar"
import { Footer } from "./Footer"
import { CookieBanner } from "./CookieBanner"
import { rtlLanguages } from "../../prismic-configuration"

const Layout = ({ children, navbar, footer, activeDocMeta }) => {
  const currentLang = activeDocMeta?.lang || "en-gb"
  const isRTL = rtlLanguages?.includes(currentLang)
  const htmlLang = currentLang.split("-")[0]
  const rtlClassName = isRTL ? "rtl-content" : ""

  return (
    <div dir={isRTL ? "rtl" : "ltr"} lang={htmlLang} className={rtlClassName}>
      {/* Conditionally load Arabic font only for RTL pages */}
      {isRTL && (
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&display=swap"
        />
      )}

      <a href="#main-content" className="skip-link">
        Skip to content
      </a>

      <Navbar navbar={navbar} activeDocMeta={activeDocMeta} />

      <main id="main-content" className="main-st">
        {children}
      </main>

      <Footer footer={footer} />
      <CookieBanner />
    </div>
  )
}

export default Layout
